import React from "react";
import * as Icons from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { SERVICES } from "../data/content";

export const Services = () => (
  <section id="services" className="relative bg-white py-24 sm:py-32" data-testid="services-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><Overline>Our Consulting Services</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            Practical solutions, engineered for <span className="text-gradient-gold">measurable outcomes</span>.
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Sparkles;
          return (
            <Reveal key={s.title} delay={i * 0.1}>
              <div data-testid={`service-card-${i}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-[1.75rem] border border-black/5 bg-bg-light p-8 card-shadow transition-transform duration-500 hover:-translate-y-1.5">
                <div className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-gold to-emerald-light transition-transform duration-500 group-hover:scale-x-100" />
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-base text-gold-light transition-colors duration-500 group-hover:bg-gold group-hover:text-emerald-darkest">
                  <Icon size={26} />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-charcoal">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/65">{s.desc}</p>
                <ul className="mt-6 space-y-2.5 border-t border-black/5 pt-6">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-start gap-2.5 text-sm text-charcoal/75">
                      <Icons.Check size={16} className="mt-0.5 shrink-0 text-emerald-light" /> {it}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
